export default function CustomTextArea({
  className = '',
  placeholder = 'Không có nội dung',

  ...props
}) {
  return (
    <textarea
      className={`rounded border bg-input-gray p-4 text-gray-accent ${className} w-full`}
      placeholder={placeholder}
      {...props}
    />
  )
}
